const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    maxWidth: minWidth / 1.5
  },
  form: {
    maxHeight: minHeight / 2,
    //overflowY: 'auto'
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,

  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  },
  upload: {
    '@supports ((-moz-appearance:none) or (-webkit-appearance:none))': {
      '& input': {
        height: '2em',
      },
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/settings/manufacturer/upload/styles.js